import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { Provider } from 'react-redux';
import store from './store';
import ProcessingPopup from './components/ProcessingPopup';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Auth0Provider } from '@auth0/auth0-react';
import VisualizerContent from './VisualizerContent';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import MemberInvite from './auth/MemberInvite';
import muiTheme from './theme';

const root = ReactDOM.createRoot(document.getElementById('root'));


root.render(
  <Provider store={store}>
    <ThemeProvider theme={muiTheme} >
      <CssBaseline />
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{  
          redirect_uri: window.location.origin,
          audience:process.env.REACT_APP_API_AUDIENCE,
          scope: "openid profile email read:dv apply:dv"
        }}
        cacheLocation='localstorage'
        >
        <Router>
          <Routes>
            <Route path="/authorize" element={<MemberInvite />} />
            <Route path="*" element={<VisualizerContent />} />
          </Routes>
        </Router>
      </Auth0Provider>
      <ProcessingPopup />
    </ThemeProvider>
  </Provider>
);